<div class="course-view-container">
  <!-- Left Sidebar - Course Navigation -->
  <aside class="course-sidebar">
    <button class="back-button" (click)="goBack()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Back to courses</span>
    </button>

    <div class="course-header-sidebar">
      <p class="course-label">Course</p>
      <h2 class="course-title-sidebar">{{ course.title }}</h2>
    </div>

    <!-- Loading State -->
    @if (isLoading()) {
      <div class="loading-state">
        <div class="spinner"></div>
        <p>Cargando curso...</p>
      </div>
    }

    <!-- Course Sections -->
    @if (!isLoading()) {
      <nav class="course-navigation">
        @for (section of courseSections; track section.id) {
          <div class="course-section">
            <button class="section-header" (click)="toggleSection(section.id)">
              <span class="section-title">{{ section.title }}</span>
              <svg 
                class="chevron" 
                [class.expanded]="section.expanded"
                width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            @if (section.expanded) {
              <!-- Descripción del módulo -->
              @if (section.descripcion) {
                <div class="module-description">
                  <p>{{ section.descripcion }}</p>
                </div>
              }

              <!-- Lista de clases -->
              @if (section.lessons.length > 0) {
                <ul class="lessons-list">
                  @for (lesson of section.lessons; track lesson.id) {
                    <li 
                      class="lesson-item" 
                      [class.completed]="lesson.completed"
                      (click)="playLesson(lesson.id)">
                      <div class="lesson-info">
                        <span class="lesson-number">{{ $index + 1 }}</span>
                        <div class="lesson-content-wrapper">
                          <span class="lesson-title">{{ lesson.title }}</span>
                          <div class="lesson-type-icon">
                            @if (lesson.type === 'video') {
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                              </svg>
                            } @else if (lesson.type === 'podcast' || lesson.type === 'audio') {
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                <line x1="12" y1="19" x2="12" y2="23"></line>
                                <line x1="8" y1="23" x2="16" y2="23"></line>
                              </svg>
                            } @else if (lesson.type === 'blog') {
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <polyline points="14 2 14 8 20 8"></polyline>
                                <line x1="16" y1="13" x2="8" y2="13"></line>
                                <line x1="16" y1="17" x2="8" y2="17"></line>
                                <polyline points="10 9 9 9 8 9"></polyline>
                              </svg>
                            }
                          </div>
                        </div>
                      </div>
                      <div class="lesson-meta">
                        @if (lesson.preview) {
                          <span class="preview-badge">Preview</span>
                        }
                        <span class="lesson-duration">{{ lesson.duration }}</span>
                        @if (lesson.completed) {
                          <svg class="check-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3 8L6 11L13 4" stroke="#77d27a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        }
                      </div>
                    </li>
                  }
                </ul>
              } @else {
                <div class="no-lessons">
                  <p>Este módulo aún no tiene clases disponibles</p>
                </div>
              }
            }
          </div>
        }
      </nav>
    }
    

    <!-- Course Index Button -->
    <button class="show-index-btn" (click)="toggleCourseIndex()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <rect x="3" y="4" width="14" height="3" rx="1" fill="currentColor"/>
        <rect x="3" y="9" width="14" height="3" rx="1" fill="currentColor"/>
        <rect x="3" y="14" width="14" height="3" rx="1" fill="currentColor"/>
      </svg>
      Ver índice
    </button>
  </aside>

  <!-- Main Content -->
  <main class="course-main-content">
    <!-- Course Header Image -->
    <div class="video-container">
      <img [src]="course.thumbnail" [alt]="course.title" class="video-thumbnail">
    </div>

    <!-- Company Logo & Actions -->
    <div class="content-header">
      <div class="instructor-info">
        <div class="company-logo">
          <img src="./assets/logo/logon.png" alt="TrAIding Lab">
        </div>
      </div>

      <div class="content-actions">
        <button class="action-btn">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 3.5C5.5 3.5 2 7 2 10C2 13 5.5 16.5 10 16.5C14.5 16.5 18 13 18 10C18 7 14.5 3.5 10 3.5Z" stroke="currentColor" stroke-width="1.5"/>
            <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" fill="currentColor"/>
          </svg>
          <span>{{ course.likes }}</span>
        </button>

        <button class="action-btn">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 8V15C15 15.5304 14.7893 16.0391 14.4142 16.4142C14.0391 16.7893 13.5304 17 13 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V5C1 4.46957 1.21071 3.96086 1.58579 3.58579C1.96086 3.21071 2.46957 3 3 3H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M17 1L19 3L11 11H9V9L17 1Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Share</span>
        </button>

        <button class="action-btn more-btn">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="5" r="1.5" fill="currentColor"/>
            <circle cx="10" cy="10" r="1.5" fill="currentColor"/>
            <circle cx="10" cy="15" r="1.5" fill="currentColor"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Description -->
    <section class="course-description">
      <h1 class="course-main-title">{{ course.title }}</h1>
      <p class="description-text">
        {{ course.subtitle }}
      </p>
    </section>

    <!-- Course Details -->
    <section class="course-details">
      <h2 class="section-title-main">Details</h2>
      <div class="details-grid">
        <div class="detail-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="detail-icon">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <div class="detail-info">
            <p class="detail-label">Duration</p>
            <p class="detail-value">{{ course.duration }}</p>
          </div>
        </div>

        <div class="detail-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="detail-icon">
            <path d="M16 18L22 12L16 6M8 6L2 12L8 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div class="detail-info">
            <p class="detail-label">Skill level</p>
            <p class="detail-value">{{ course.level }}</p>
          </div>
        </div>

        <div class="detail-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="detail-icon">
            <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
          </svg>
          <div class="detail-info">
            <p class="detail-label">Views</p>
            <p class="detail-value">{{ course.views | number }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ -->
    <!-- <section class="faq-section">
      <h2 class="section-title-main">Frequently asked questions</h2>
      <div class="faq-list">
        @for (faq of faqs; track $index) {
          <div class="faq-item" [class.expanded]="faq.expanded">
            <button class="faq-question" (click)="toggleFAQ($index)">
              <span>{{ faq.question }}</span>
              <svg 
                class="faq-chevron" 
                [class.expanded]="faq.expanded"
                width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            @if (faq.expanded) {
              <div class="faq-answer">
                <p>{{ faq.answer }}</p>
              </div>
            }
          </div>
        }
      </div>
    </section> -->
  </main>

  <!-- Right Sidebar - Purchase Info -->
  <aside class="purchase-sidebar">
    <div class="purchase-card">
      <!-- Price -->
      <div class="price-section" style="display: none;">
        @if (course.isSubscribed) {
          <p class="price-label">Acceso</p>
          <div class="included-badge">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="9" stroke="#77d27a" stroke-width="2"/>
              <path d="M6 10L9 13L14 8" stroke="#77d27a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Curso incluido</span>
          </div>
        } @else {
          <p class="price-label">Precio</p>
          <div class="price-info">
            <span class="current-price">${{ course.price }}</span>
            <span class="original-price">${{ course.originalPrice }}</span>
            <span class="discount-badge">{{ course.discount }}</span>
          </div>
        }
      </div>

      <!-- Includes -->
      <div class="includes-section">
        <h3 class="includes-title">Course includes:</h3>
        <ul class="includes-list">
          @for (item of course.includes; track item) {
            <li class="include-item">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <span>{{ item }}</span>
            </li>
          }
        </ul>
      </div>

      <!-- Actions -->
      <button class="btn-start-course" (click)="startCourse()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M6 4L16 10L6 16V4Z" fill="currentColor"/>
        </svg>
        Iniciar curso
      </button>
      <div class="subscription-badge">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 1L10 5.5L15 6.13L11.5 9.5L12.32 14.36L8 12L3.68 14.36L4.5 9.5L1 6.13L6 5.5L8 1Z" fill="#77d27a"/>
        </svg>
        <span>Incluido en tu suscripción</span>
      </div>

      <!-- Rating -->
      <div class="rating-section">
        <div class="rating-emoji"></div>
        <div class="rating-info">
          <h4 class="rating-title">Rating</h4>
          <div class="rating-stars">
            @for (star of [1,2,3,4,5]; track star) {
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 1L10 5.5L15 6.13L11.5 9.5L12.32 14.36L8 12L3.68 14.36L4.5 9.5L1 6.13L6 5.5L8 1Z" [attr.fill]="star <= course.rating ? '#FFB800' : 'none'" [attr.stroke]="star <= course.rating ? '#FFB800' : 'currentColor'" stroke-width="1.5"/>
              </svg>
            }
          </div>
          <p class="rating-meta">{{ course.rating }} ({{ course.totalRatings }} ratings)</p>
          <p class="students-count">{{ course.students | number }} Students</p>
        </div>
      </div>

      <!-- Publisher Info -->
     

      <!-- Suggested Courses -->
      
    </div>
  </aside>

  <!-- Course Index Modal -->
  @if (showCourseIndex()) {
    <div class="modal-overlay" (click)="toggleCourseIndex()">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h2 class="modal-title">{{ course.title }}</h2>
          <button class="modal-close" (click)="toggleCourseIndex()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <p class="modal-subtitle">{{ course.sections }} sections • {{ course.lectures }} lectures • {{ course.duration }} total length</p>

        <div class="modal-sections">
          @for (section of courseSections; track section.id) {
            <div class="modal-section">
              <button class="modal-section-header" (click)="toggleSection(section.id)">
                <svg 
                  class="modal-chevron" 
                  [class.expanded]="section.expanded"
                  width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="modal-section-title">{{ section.title }}</span>
              </button>

              @if (section.expanded) {
                <div class="modal-lessons">
                  @for (lesson of section.lessons; track lesson.id) {
                    <div class="modal-lesson">
                      @if (lesson.thumbnail) {
                        <img [src]="lesson.thumbnail" [alt]="lesson.title" class="modal-lesson-thumb">
                      } @else {
                        <div class="modal-lesson-placeholder">
                          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path d="M10 8L22 16L10 24V8Z" fill="currentColor"/>
                          </svg>
                        </div>
                      }
                      <div class="modal-lesson-info">
                        <h4 class="modal-lesson-title">{{ lesson.title }}</h4>
                        <p class="modal-lesson-duration">{{ lesson.duration }}</p>
                      </div>
                      @if (lesson.completed) {
                        <div class="modal-progress-bar">
                          <div class="modal-progress-fill" style="width: 100%"></div>
                        </div>
                        <span class="modal-progress-text">100%</span>
                      } @else {
                        <div class="modal-progress-bar">
                          <div class="modal-progress-fill" style="width: 0%"></div>
                        </div>
                        <span class="modal-progress-text">0%</span>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>

